import {
  isCirculoTemplate,
  isGTopTemplate
} from "../../components/mixins";
import { ref } from "vue";

const getOrganizationData = (): {
  organizationName: string;
  organizationId: string;
} => {
  if (isGTopTemplate()) {
    return { organizationName: "Grupo Gtop", organizationId: "16202495" };
  } else if (isCirculoTemplate()) {
    return { organizationName: "Círculo Ltda", organizationId: "2167376" };
  } else {
    return { organizationName: "Lince Tech", organizationId: "69249461" };
  }
};

const isMobile = ref(window.innerWidth <= 755);

window.addEventListener("resize", () => {
  isMobile.value = window.innerWidth <= 755;
});

export const addCertificateToLinkedIn = async (certificateData: {
  name: string;
  certificateUrl: string;
  certificateId: string;
  issueYear?: number;
  issueMonth?: number;
}): Promise<void> => {
  try {
    const {
      name,
      certificateUrl,
      certificateId,
      issueYear,
      issueMonth
    } = certificateData;

    const { organizationName, organizationId } = getOrganizationData();

    let linkedinProfileURL =
      `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME` +
      `&name=${encodeURIComponent(name)}` +
      `&organizationName=${encodeURIComponent(organizationName)}` +
      `&certUrl=${encodeURIComponent(certificateUrl)}` +
      `&certId=${certificateId}` +
      `&organizationId=${organizationId}`;

    if (issueYear && issueMonth) {
      linkedinProfileURL += `&issueYear=${issueYear}&issueMonth=${issueMonth}`;
    }

    if (isMobile.value) {
      window.location.href = linkedinProfileURL;
    } else {
      window.open(linkedinProfileURL, "_blank");
    }
  } catch (e) {
    console.error("Erro ao adicionar certificado ao LinkedIn:", e);
    throw e;
  }
};
